import { useSearchParams } from 'react-router-dom';
import { ForgotPasswordForm } from '../ForgotPasswordForm/ForgotPasswordForm';
import { PasswordResetForm } from '../PasswordResetForm/PasswordResetForm';
import { LoginLayout } from '../../../layouts/Login/LoginLayout';
import logoImage from '../../../assets/images/logo-dark.png';

export const ForgotPasswordPage = () => {
  const [query] = useSearchParams();
  const token: string | null = query.get('token');
  const userId: string | null = query.get('userId');
  return (
    <LoginLayout>
      <div className="loginFormContainer">
        <div className="logoContainer">
          <img src={logoImage} alt="" />
        </div>
        {(!token || !userId) && <ForgotPasswordForm />}
        {token && userId && <PasswordResetForm token={token} userId={userId} />}
      </div>
    </LoginLayout>
  );
};
